import React, { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import css from './ellipsis.module.css'

interface Props {
    children: ReactNode
    tagName?: string
    className?: string
    style?: CSSProperties
    title?: string
    fullTextOnHover?: boolean
    [key: string]: any
}

const Ellipsis = ({
    children,
    tagName = 'div',
    className,
    style = {},
    title,
    fullTextOnHover = false,
    ...rest
}: Props) => {
    const [hasOverflow, setHasOverflow] = useState(false)
    const ref = useRef<HTMLSpanElement>(null)
    const props = {
        style,
        title:
            title ??
            (fullTextOnHover && typeof children === 'string' && hasOverflow ? children : undefined),
        className: [css.ellipsis, className || ''].join(' '),
        ...rest,
    }

    useEffect(() => {
        const innerElem = ref.current
        const parentElement = innerElem?.parentElement

        if (!fullTextOnHover || !innerElem || !parentElement) {
            return
        }

        const checkOverflow = () =>
            setHasOverflow(parentElement.scrollWidth > parentElement.clientWidth)

        const resizeObserver = new ResizeObserver(checkOverflow)
        resizeObserver.observe(innerElem)
        resizeObserver.observe(parentElement)

        return () => resizeObserver.disconnect()
    }, [fullTextOnHover])

    return React.createElement(
        tagName,
        props,
        fullTextOnHover ? <span ref={ref}>{children}</span> : children,
    )
}

export default Ellipsis
